const validateLink = (value: string) => value?.length > 0;

export { validateLink };
